import { createSelector, createFeatureSelector } from "@ngrx/store";
import { CheckoutState } from "app/_store";

const checkoutStateSelector = createFeatureSelector<CheckoutState>("checkout");

export const checkoutMobileSetupSelector = createSelector(
	checkoutStateSelector,
	(state) => state?.steps?.setup?.mobile
);
